export default class TestComponent {
	constructor() {
		console.log('Test component initialized!');
	}
}